const backendUrl = process.env.REACT_APP_BACKEND_URL;
export const API = `${backendUrl}/api/cfo`;

const auth = (token) => ({ Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' });

const json = async (res) => {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.detail || `Request failed (${res.status})`);
  return data;
};

export const getMeta = (token) => fetch(`${API}/meta`, { headers: auth(token) }).then(json);
export const getDashboard = (token, period = 'this_month', from, to) => {
  const p = new URLSearchParams({ period });
  if (from) p.append('from', from);
  if (to) p.append('to', to);
  return fetch(`${API}/dashboard?${p}`, { headers: auth(token) }).then(json);
};
export const getInsights = (token, refresh = false) => fetch(`${API}/insights?refresh=${refresh}`, { headers: auth(token) }).then(json);
export const getForecast = (token) => fetch(`${API}/forecast`, { headers: auth(token) }).then(json);
export const getOptimiser = (token, refresh = false) => fetch(`${API}/optimiser?refresh=${refresh}`, { headers: auth(token) }).then(json);
export const getSavings = (token) => fetch(`${API}/savings`, { headers: auth(token) }).then(json);
export const markSaving = (token, body) => fetch(`${API}/savings`, { method: 'POST', headers: auth(token), body: JSON.stringify(body) }).then(json);
export const unmarkSaving = (token, merchantKey) => fetch(`${API}/savings/${encodeURIComponent(merchantKey)}`, { method: 'DELETE', headers: auth(token) }).then(json);
export const listTx = (token, params = {}) => {
  const p = new URLSearchParams(params);
  return fetch(`${API}/transactions?${p}`, { headers: auth(token) }).then(json);
};
export const createTx = (token, body) => fetch(`${API}/transactions`, { method: 'POST', headers: auth(token), body: JSON.stringify(body) }).then(json);
export const patchTx = (token, id, body) => fetch(`${API}/transactions/${id}`, { method: 'PATCH', headers: auth(token), body: JSON.stringify(body) }).then(json);
export const deleteTx = (token, id) => fetch(`${API}/transactions/${id}`, { method: 'DELETE', headers: auth(token) }).then(json);
export const putSettings = (token, body) => fetch(`${API}/settings`, { method: 'PUT', headers: auth(token), body: JSON.stringify(body) }).then(json);
export const extractFile = (token, file) => {
  const fd = new FormData();
  fd.append('file', file);
  return fetch(`${API}/extract`, { method: 'POST', headers: { Authorization: `Bearer ${token}` }, body: fd }).then(json);
};
export const getChatHistory = (token, sessionId) => fetch(`${API}/chat/${sessionId}`, { headers: auth(token) }).then(json);

// Streaming chat — onToken(chunk) called as text arrives.
export const streamChat = async (token, sessionId, message, onToken) => {
  const res = await fetch(`${API}/chat`, { method: 'POST', headers: auth(token), body: JSON.stringify({ session_id: sessionId, message }) });
  if (!res.ok || !res.body) throw new Error('Chat failed');
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    onToken(decoder.decode(value, { stream: true }));
  }
};

export const CUR = (v, currency = 'AUD') => {
  const n = Number(v || 0);
  const sign = n < 0 ? '-' : '';
  const a = Math.abs(n);
  if (a >= 1_000_000) return `${sign}$${(a / 1_000_000).toFixed(a % 1_000_000 === 0 ? 0 : 2)}M`;
  if (a >= 1_000) return `${sign}$${(a / 1_000).toFixed(a >= 100_000 ? 0 : 1)}k`;
  return `${sign}$${a.toLocaleString('en-AU', { maximumFractionDigits: 0 })}`;
};
export const CUR_FULL = (v) => `$${Number(v || 0).toLocaleString('en-AU', { maximumFractionDigits: 2 })}`;
